import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { FaOpenid } from "react-icons/fa6";
import { MdClose, MdPower, MdPowerOff } from "react-icons/md";
import ShinyCard from "src/components/BankCard/ShinyCard";
import Modal from "src/components/Modal/Modal";
import useModalsStore from "src/store/modalsStore";
import { useState } from "react";
import useCurrentUser from "src/hooks/useCurrentUser";
import ButtonGroup from "src/components/ButtonGroup/ButtonGroup";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "src/components/Button/Button.types";

const OpenAiConnectorModal: React.FC = () => {
  const { t } = useTranslation();
  const { setShowOpenAiApiModal } = useModalsStore();
  const { userInfo } = useCurrentUser();
  const [isConnecting, setIsConnecting] = useState<boolean>(false);
  const [isDisconnecting, setIsDisconnecting] = useState<boolean>(false);
  const [isLoadingOpenAi, setIsLoadingOpenAi] = useState<boolean>(false);
  const [isOpenAiConnected, setIsOpenAiConnected] = useState<boolean>(false);
  const [canUseOpenAi, setCanUseOpenAi] = useState<boolean>(false);

  return (
    <Modal
      onEscape={() => setShowOpenAiApiModal(false)}
      className={clsx(["md:!w-full", "md:!max-w-[400px]"])}
    >
      <Modal.Header
        onClose={() => setShowOpenAiApiModal(false)}
        title="Información de extensión"
        isClosable={!isConnecting || !isDisconnecting}
      />

      <Modal.Body>
        <div
          className={clsx(["flex", "w-full", "flex-col", "gap-4", "md:gap-6"])}
        >
          <div className={clsx(["flex", "flex-col", "w-full", "gap-4"])}>
            <div
              className={clsx([
                "flex",
                "w-full",
                "items-center",
                "flex-row",
                "gap-4",
              ])}
            >
              <div
                className={clsx([
                  "rounded",
                  "inline-flex",
                  "h-[70px]",
                  "w-[70px]",
                  "items-center",
                  "justify-center",
                  "dark:bg-black",
                  "bg-gray-200",
                ])}
              >
                <ShinyCard>
                  <div
                    className={clsx([
                      "h-full",
                      "w-full",
                      "items-center",
                      "justify-center",
                      "flex",
                    ])}
                  >
                    <FaOpenid size={ICON_SIZES.LG} />
                  </div>
                </ShinyCard>
              </div>
              <div className={clsx(["text-left"])}>
                <div className={clsx(["font-medium"])}>OpenAI GPT</div>
                <div className={clsx(["text-xs"])}>
                  {isLoadingOpenAi
                    ? t("Cargando estado...")
                    : isOpenAiConnected
                      ? t("Vinculado correctamente")
                      : t("No tienes una cuenta vinculada")}
                </div>
              </div>
            </div>

            <div className={clsx(["flex", "flex-col", "gap-4"])}>
              <div className={clsx(["text-sm"])}>
                Te permite utilizar tu propia API key de OpenAI para crear
                transacciones apartir de facturas, recibos y tickets en formato
                imagen.
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer
        leftContent={
          <ButtonGroup
            buttons={
              isLoadingOpenAi
                ? []
                : [
                    {
                      text: t("Desvincular"),
                      onClick: async () => {},
                      kind: EButtonKind.DANGER,
                      icon: <MdPowerOff size={ICON_SIZES.SM} />,
                      isLoading: isDisconnecting,
                      disabled: isDisconnecting,
                      hide: !canUseOpenAi,
                    },
                    {
                      text: t("Vincular"),
                      onClick: () => {},
                      kind: EButtonKind.SAVE,
                      icon: <MdPower size={ICON_SIZES.SM} />,
                      isLoading: isConnecting,
                      disabled: isConnecting,
                      hide: canUseOpenAi,
                    },
                  ]
            }
          />
        }
        actions={[
          {
            text: t("common:buttons.close"),
            onClick: () => setShowOpenAiApiModal(false),
            kind: EButtonKind.NORMAL,
            icon: <MdClose size={ICON_SIZES.SM} />,
            disabled: isConnecting || isDisconnecting,
          },
        ]}
      />
    </Modal>
  );
};

export default OpenAiConnectorModal;
